import { render } from "./HomeIcon.vue?vue&type=template&id=8bd87efc&scoped=true"
const script = {}

import "./HomeIcon.vue?vue&type=style&index=0&id=8bd87efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd87efc"]])

export default __exports__